/* Adam Home collection page: Shopify sort_by on change, and "load more as you scroll" layered over the
   crawlable ?page=N links (the links stay in the HTML for crawlers and no-JS visitors). */
(function () {
  var form = document.querySelector('[data-sort-form]');
  if (form) form.addEventListener('change', function () { form.submit(); });

  /* on-brand sort menu over the real <select> (kept for no-JS and as the source of truth) */
  var sel = form && form.querySelector('select');
  if (sel) (function () {
    var opts = Array.prototype.map.call(sel.options, function (o) { return { v: o.value, t: o.textContent }; });
    var wrap = document.createElement('div'); wrap.className = 'sortx';
    var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'sortx__btn';
    btn.setAttribute('aria-haspopup', 'listbox'); btn.setAttribute('aria-expanded', 'false');
    var list = document.createElement('div'); list.className = 'sortx__menu'; list.setAttribute('role', 'listbox'); list.tabIndex = -1; list.setAttribute('aria-label', 'Sort products');
    list.innerHTML = '<p class="sortx__head">Sort by</p>' + opts.map(function (o, i) {
      return '<button type="button" role="option" class="sortx__opt" data-i="' + i + '" aria-selected="' + (o.v === sel.value) + '"><span>' + o.t + '</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></button>';
    }).join('');
    var scrim = document.createElement('div'); scrim.className = 'sortx__scrim';
    function label() { btn.innerHTML = '<span class="sortx__k">Sort</span><span class="sortx__v">' + sel.options[sel.selectedIndex].textContent + '</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>'; }
    function open(on) {
      wrap.classList.toggle('is-open', on); btn.setAttribute('aria-expanded', on);
      if (on) { var cur = list.querySelector('[aria-selected="true"]') || list.querySelector('.sortx__opt'); setTimeout(function () { cur.focus(); }, 30); }
    }
    btn.addEventListener('click', function () { open(!wrap.classList.contains('is-open')); });
    scrim.addEventListener('click', function () { open(false); });
    list.addEventListener('click', function (e) {
      var o = e.target.closest('.sortx__opt'); if (!o) return;
      var i = +o.getAttribute('data-i'); open(false);
      if (sel.selectedIndex !== i) { sel.selectedIndex = i; label(); wrap.classList.add('is-busy'); form.submit(); }
    });
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { open(false); btn.focus(); return; }
      if (!wrap.classList.contains('is-open') || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp')) return;
      e.preventDefault(); var all = [].slice.call(list.querySelectorAll('.sortx__opt')), k = all.indexOf(document.activeElement);
      all[(k + (e.key === 'ArrowDown' ? 1 : all.length - 1)) % all.length].focus();
    });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) open(false); });
    label(); wrap.appendChild(btn); wrap.appendChild(scrim); wrap.appendChild(list);
    sel.classList.add('sortx__native'); sel.tabIndex = -1; sel.setAttribute('aria-hidden', 'true');
    var lab = form.querySelector('label'); if (lab) lab.hidden = true;
    form.appendChild(wrap);
    /* sit in the right corner of the "N designs" row, so the chips keep the full width */
    var count = document.querySelector('.count');
    if (count) { var row = document.createElement('div'); row.className = 'count-row'; count.parentNode.insertBefore(row, count); row.appendChild(count); row.appendChild(form); }
  })();

  var more = document.querySelector('[data-more]'), grid = document.querySelector('[data-grid]');
  if (!more || !grid || !more.getAttribute('data-next')) return;
  var pager = more.querySelector('[data-pager]'), btn = more.querySelector('[data-load-more]'), busy = false;
  var total = +more.getAttribute('data-total'), noun = more.getAttribute('data-noun');
  var status = document.createElement('span'); more.appendChild(status);
  if (pager) pager.hidden = true; if (btn) btn.hidden = false;
  function done() { if (btn) btn.remove(); status.textContent = 'Showing all ' + total + ' ' + noun + '.'; }
  function next() {
    var url = more.getAttribute('data-next'); if (busy || !url) return; busy = true; status.textContent = 'Loading more…';
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var g = doc.querySelector('[data-grid]'), m = doc.querySelector('[data-more]');
      if (g) Array.prototype.forEach.call(g.children, function (c) { grid.appendChild(document.importNode(c, true)); });
      var n = m && m.getAttribute('data-next');
      if (n) { more.setAttribute('data-next', n); status.textContent = ''; } else { more.removeAttribute('data-next'); done(); }
      busy = false;
    }).catch(function () { busy = false; if (pager) pager.hidden = false; status.textContent = ''; });
  }
  if (btn) btn.addEventListener('click', next);
  if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { if (e[0].isIntersecting) next(); }, { rootMargin: '900px 0px' }).observe(more);
})();
